module.exports = __webpack_public_path__ + "static/img/card-card-4.91a25f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-card-4.jpg
// module id = TtJf
// module chunks = 1